export const payload = {
  receiveMutation: 'RECEIVE_BANKS',
  receivingMutation: 'RECEIVING_BANKS',
  receiveMetadataMutation: 'RECEIVE_BANK_METADATA',
  receiveFailureMutation: 'RECEIVE_BANK_FAILURE',
  savingMutation: 'SAVING_BANK',
  saveFailureMutation: 'SAVING_BANK_FAILURE',
  incrementMutation: 'INCREMENT_BANK_COUNT',
  updatingMutation: 'UPDATING_BANK',
  updateFailureMutation: 'UPDATING_BANK_FAILURE',
  deleteMutation: 'DELETE_BANK',
  deletingMutation: 'DELETING_BANK',
  deleteFailureMutation: 'DELETING_BANK_FAILURE',
  resetMetaMutation: 'RESET_BANK_META',
  clearMutation: 'CLEAR_BANK_STATE',
  moduleName: 'bank',
  endpoint: 'banks',
  defaultModelGetter: 'getDefaultBank'
}
